export function getShipmentValues(shipment) {
  const values = {
    bol: shipment.bol,
    shipmentId: shipment.shipmentId,
    carrierName: shipment.carrierName,
    notes: shipment.notes,
    orderNumber: shipment.orderNumber,
    totalPieces: shipment.totalPieces,
    billingQuantities: shipment.billingQuantities,
    customerPoNumber: shipment.customerPoNumber,
    weightUnits: shipment.weightUnits,
    totalWeight: shipment.totalWeight,
    vendorName: shipment.vendorName,
    trackingNumber: shipment.trackingNumber,
    startTime: shipment.startTime,
    completeTime: shipment.completeTime,
    receivedAt: shipment.receivedAt,
    draft: shipment.draft,
    truckNumber: shipment.truckNumber,
    billingType: shipment.billingType,
  };

  if (shipment.costCenter?.id) {
    values.costCenterId = parseInt(shipment.costCenter.id, 10);
  }

  return values;
}
